import React from 'react'

import { SignatureProps, buildSignatureModel } from '@/components/EmailSignaturePreview/signature'
import {
  ContactRows,
  SignatureActions,
  SignatureFrame,
  SignatureIdentity,
  SignatureLogo,
  SignatureNotes,
  Stack,
  VerticalRule,
  collectContactEntries,
} from '@/components/EmailSignaturePreview/TableSignature/parts'

const LOGO = 64
const GUTTER = 18

/**
 * Mark left — the arrangement almost every corporate signature uses. The mark, a brand rule,
 * then the details. It holds on a phone because the left side is a fixed 83px: only the text
 * column narrows.
 */
const ClassicTable = ({ interactive, ...props }: SignatureProps & { interactive?: boolean }) => {
  const model = buildSignatureModel(props)
  const entries = collectContactEntries(model)

  return (
    <SignatureFrame>
      <tr>
        <td
          valign="top"
          width={LOGO + GUTTER}
          style={{ width: `${LOGO + GUTTER}px`, paddingRight: `${GUTTER}px`, verticalAlign: 'top' }}
        >
          <SignatureLogo model={model} interactive={interactive} size={LOGO} />
        </td>

        <VerticalRule color={model.brandEdge} width={2} gutter={GUTTER} />

        <td valign="top" style={{ verticalAlign: 'top' }}>
          <Stack gap={12}>
            <SignatureIdentity model={model} />
            <ContactRows
              entries={entries}
              interactive={interactive}
              assetBaseUrl={model.assetBaseUrl}
            />
            <SignatureActions model={model} interactive={interactive} />
            <SignatureNotes model={model} />
          </Stack>
        </td>
      </tr>
    </SignatureFrame>
  )
}

export default ClassicTable
